"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AvenAdvisorLienMatchRequirement = exports.AvenAdvisorCalculationDataReportsUsed = exports.AvenAdvisorCalculationType = void 0;
exports.isAvenAdvisorDtiCalculationsResponse = isAvenAdvisorDtiCalculationsResponse;
exports.isMissingDataReports = isMissingDataReports;
/** @TranslateToPython @TranslateToEnum */
var AvenAdvisorCalculationType;
(function (AvenAdvisorCalculationType) {
    AvenAdvisorCalculationType["DTI"] = "DTI";
    AvenAdvisorCalculationType["ALL_EXPERIAN_ONLY_CALCULATIONS"] = "ALL_EXPERIAN_ONLY_CALCULATIONS";
    AvenAdvisorCalculationType["ALL_IRS_ONLY_CALCULATIONS"] = "ALL_IRS_ONLY_CALCULATIONS";
    AvenAdvisorCalculationType["LIEN_INFO"] = "LIEN_INFO";
})(AvenAdvisorCalculationType || (exports.AvenAdvisorCalculationType = AvenAdvisorCalculationType = {}));
/** @TranslateToPython @TranslateToEnum */
var AvenAdvisorCalculationDataReportsUsed;
(function (AvenAdvisorCalculationDataReportsUsed) {
    AvenAdvisorCalculationDataReportsUsed["experianPremierAttributesAndTrendedTradelinesReport"] = "experianPremierAttributesAndTrendedTradelinesReport";
    AvenAdvisorCalculationDataReportsUsed["plaidAssetReport"] = "plaidAssetReport";
    AvenAdvisorCalculationDataReportsUsed["homeReport"] = "homeReport";
    AvenAdvisorCalculationDataReportsUsed["coreLogicTransactionHistoryReport"] = "coreLogicTransactionHistoryReport";
    AvenAdvisorCalculationDataReportsUsed["irsReport"] = "irsReport";
})(AvenAdvisorCalculationDataReportsUsed || (exports.AvenAdvisorCalculationDataReportsUsed = AvenAdvisorCalculationDataReportsUsed = {}));
/** @TranslateToPython @TranslateToEnum */
var AvenAdvisorLienMatchRequirement;
(function (AvenAdvisorLienMatchRequirement) {
    AvenAdvisorLienMatchRequirement["onlyExperianMatches"] = "onlyExperianMatches";
    AvenAdvisorLienMatchRequirement["atLeastOneExperianMatch"] = "atLeastOneExperianMatch";
    AvenAdvisorLienMatchRequirement["allMatches"] = "allMatches";
})(AvenAdvisorLienMatchRequirement || (exports.AvenAdvisorLienMatchRequirement = AvenAdvisorLienMatchRequirement = {}));
function isAvenAdvisorDtiCalculationsResponse(obj) {
    return typeof obj === 'object' && obj !== null && (typeof obj?.grossAnnualIncome === 'number' || typeof obj?.monthlyDebtPayments === 'number' || typeof obj?.debtToIncomeRatio === 'number');
}
function isMissingDataReports(obj) {
    return (Array.isArray(obj) &&
        obj.every((item) => {
            return Object.values(AvenAdvisorCalculationDataReportsUsed).includes(item);
        }));
}
